//In development allow passing cookies on cross origin requests. (Useful if building app is hosted on a different origin to this app)
import axios from "axios";
import qs from "qs";

if (process.env.NODE_ENV === "development") {
  axios.defaults.withCredentials = true
}

axios.defaults.headers.common['X-RDS-AJAX'] = "true";

axios.defaults.paramsSerializer = function(params) {return qs.stringify(params)};

const ContentType = {
  form: 'application/x-www-form-urlencoded',
  json: 'application/json'
}

const handleResponse = (response) => {
  if(response.data && response.data.ajax_redirect)
  {
    //Server has requested some action be taken (eg. password recovery questions need to be set)
    //let redirect = response.data.ajax_redirect;
    //throwRedirectError(redirect)
  }
  else {
    return response
  }
}

const handleError = (error) => {
  if (error.response) {
    throw error.response
  }
  else {
    throw error
  }
}

function getJson(url, params = {}) {
  return get(
    url,
    params,
    {'Accept': ContentType.json}
  )
}

function postJson(url, data) {
  return post(
    url,
    data,
    {'Content-Type': ContentType.json}
  )
}

function deleteEntity(url, params = {}, headers) {
  return axios.delete(
    url,
    {
      params,
      'headers': headers
    }
  ).then(
    handleResponse,
    handleError
  );
}


function get(url, params = {}, headers) {
  return axios.get(
    url,
    {
      params,
      'headers': headers
    }
  ).then(
    handleResponse,
    handleError
  );
}

function post(url, data, headers) {
  return axios.post(
    url,
    data,
    {'headers': headers}
  ).then(
    handleResponse,
    handleError
  );
}



export {getJson, postJson, deleteEntity};